import { EMPTY_CELL, formatCount } from './rosterUploadFormat';
import { AdminPanel } from '../AdminPage';

interface RosterUploadPlayersTableProps {
  columns: readonly string[];
  players: readonly (readonly (string | null)[])[];
  truncated: boolean;
  /** The full count, when known, so a truncated table can say how much is missing. */
  playerCount: number | null;
}

/**
 * The extracted players exactly as the extraction produced them. The columns vary per upload (a
 * showcase roster carries a team column, a CSV whatever headers it had), so they come from the
 * response rather than from a fixed schema. Scrolls sideways inside its own box on a narrow screen.
 */
export const RosterUploadPlayersTable = ({
  columns,
  players,
  truncated,
  playerCount,
}: RosterUploadPlayersTableProps) => (
  <AdminPanel
    title={`Extracted players (${formatCount(playerCount ?? players.length)})`}
    titleId="roster-upload-players-title"
  >
    {truncated && (
      <p className="roster-upload__note" data-testid="roster-upload-truncated">
        Showing the first {formatCount(players.length)}
        {playerCount !== null && playerCount > players.length
          ? ` of ${formatCount(playerCount)}`
          : ''}{' '}
        players.
      </p>
    )}

    {players.length === 0 || columns.length === 0 ? (
      <p className="admin-state">No players were extracted from this upload.</p>
    ) : (
      <div className="data-table-card">
        <div className="data-table-wrap">
          <table className="data-table roster-upload__players" data-testid="roster-upload-players">
            <thead>
              <tr>
                <th scope="col" className="roster-uploads__numeric">
                  #
                  <span className="roster-uploads__sr-only"> (row)</span>
                </th>
                {columns.map((column, index) => (
                  <th scope="col" key={`${index}-${column}`}>
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {players.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td className="roster-uploads__numeric data-table__muted">{rowIndex + 1}</td>
                  {columns.map((column, columnIndex) => {
                    const value = row[columnIndex];
                    return (
                      <td key={`${columnIndex}-${column}`}>
                        {value === null || value === undefined || value === '' ? (
                          <span className="data-table__muted">{EMPTY_CELL}</span>
                        ) : (
                          value
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )}
  </AdminPanel>
);
